<template>
  <transition name="el-fade-in-linear">
    <div v-show="transitionshow">

      <el-form :inline="true" class="backborder1 demo-form-inline" size="small">
        <el-form-item>
          <el-date-picker v-model="query.date" type="daterange" range-separator="至" start-placeholder="开始日期"
            end-placeholder="结束日期" value-format="yyyy-MM-dd" style="width: 230px"></el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-select v-model="query.express_id" clearable placeholder="请选择快递公司">
            <el-option v-for="item in logisticsList" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <!-- <el-form-item>
          <el-select v-model="query.keytype" @change="query.ischange = true">
            <el-option v-for="(item, index) in keytypelists" :label="item.name" :value="item.id"
              :key="index"></el-option>
          </el-select>
        </el-form-item> -->
        <el-form-item>
          <el-input placeholder="快递单号/销售单号" v-model="query.documents" clearable style="width:100%" />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" size="mini" icon="el-icon-search" circle @click="handleSearch"></el-button>
          <!-- <el-button type="danger" size="mini" icon="el-icon-plus" circle @click="addlogisticsorder"></el-button> -->
          <!-- <el-button type="warning" size="mini" icon="el-icon-upload2" circle @click="getsender"></el-button>
          <el-button type="warning" size="mini" icon="el-icon-download" circle @click="getrecieverlists"></el-button>
          <el-tooltip class="item" effect="dark" content="导出物流订单信息" placement="top">
            <el-button type="success" size="mini" icon="el-icon-download" circle @click="outputshippings"></el-button>
          </el-tooltip> -->
          <!-- <el-tooltip class="item" effect="dark" content="查看物流信息" placement="top">
            <el-button type="success" size="mini" icon="el-icon-view" circle @click="lookshipping"></el-button>
          </el-tooltip> -->
          <!-- <el-button type="success" size="mini" icon="el-icon-printer" round @click="print_direct">快速打印电子面单</el-button> -->
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="print_direct()">批量打印面单</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-download" @click="outputshippings">导出</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="getsender">发货人信息</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="getrecieverlists">收货人信息</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="openExpressStatistics">面单统计</el-button>
        </el-form-item>
      </el-form>

      <div class="backborder2" style="margin-top:10px">
        <el-table :data="printlists" v-loading="query.loading" @selection-change="handleSelectionChange">
          <el-table-column type="selection" width="55"></el-table-column>
          <el-table-column label="id" prop="id" align="left" width="70"></el-table-column>
          <el-table-column label="快递信息" prop="id" align="left" width="250">
            <template slot-scope="scope">
              <span v-if="scope.row.logistics_code">
                {{ scope.row.logistics_name }} | {{ scope.row.logistics_code }}
              </span>

              <span v-else style="color: red;">暂无面单，需重新获取</span>

            </template>
          </el-table-column>
          <el-table-column label="销售单号" prop="documents" align="left" width="150"></el-table-column>
          <el-table-column label="收件人信息" align="left" width="300">
            <template slot-scope="scope">
              <div>{{ scope.row.recieve_name }} {{ scope.row.recieve_phone }}</div>
              <div>{{ scope.row.recieve_province_name }}{{ scope.row.recieve_city_name }}{{ scope.row.recieve_area }}{{
                scope.row.recieve_address }}</div>
            </template>
          </el-table-column>
          <el-table-column label="打印状态" prop="id" align="left">
            <template slot-scope="scope">
              <span v-if="scope.row.is_print == 1" style="color: #67C23A;">已打印</span>
              <span v-else>未打印</span>
            </template>
          </el-table-column>
          <!-- <el-table-column label="商品重量(kg)" prop="weight" align="left"></el-table-column> -->
          <el-table-column label="添加人" prop="manager_name" align="center" width="180"></el-table-column>
          <el-table-column label="添加时间" prop="inputtime" align="center" width="180"></el-table-column>
          <!-- <el-table-column label="打印单号" prop="documents" align="center" width="180"></el-table-column> -->
          <el-table-column label="操作" align="center" width="320">
            <template slot-scope="scope">
              <el-button type="primary" :disabled="scope.row.recycle_status != 1" size="mini"
                @click="print_direct(scope.row)">打印面单</el-button>
              <el-button size="mini" @click="showLogisticsDetails(scope.row)">物流信息</el-button>
              <el-button type="warning" @click="recycleExpress(scope.row)" v-if="scope.row.recycle_status == 1"
                size="mini">回收面单</el-button>
              <el-button type="primary" @click="getExpress(scope.row)" v-else size="mini">获取面单</el-button>
            </template>
            <!-- <template slot-scope="scope">
              <el-button type="warning" size="mini" icon="el-icon-edit" circle
                @click="getshippinglogistics(scope.row)"></el-button>
              <el-tooltip class="item" effect="dark" content="打印电子面单" placement="top">
                <el-button type="warning" size="mini" icon="el-icon-view" circle
                  @click="printshippinglogistics(scope.row)"></el-button>
              </el-tooltip>
              <el-tooltip class="item" effect="dark" content="查看打印单物流信息" placement="top">
                <el-button type="success" size="mini" icon="el-icon-view" circle
                  @click="checkshippings(scope.row)"></el-button>
              </el-tooltip>
              <el-button type="danger" size="mini" icon="el-icon-delete" circle
                @click="deleteshippinglogistics(scope.row)"></el-button>
            </template> -->
          </el-table-column>
        </el-table>
        <div class="block">
          <!--分页begin-->
          <el-pagination @size-change="printPageSizeChange" @current-change="printPageCurrentChange"
            :current-page="query.p" :page-sizes="[10, 20, 50]" :page-size="query.rollpage"
            layout="total, sizes, prev, pager, next, jumper" :total="printrows">
          </el-pagination>
          <!--分页end-->
        </div>
      </div>

      <!-- 寄件人信息管理 -->
      <el-dialog title="查看发货人信息" :visible.sync="senderDialog" width="55%" top="10vh">
        <el-form :inline="true" class="demo-form-inline" size="mini">
          <el-form-item>
            <el-input placeholder="请输入关键字" v-model="senderquery.key" @keyup.enter.native.prevent="getsenderlistsdata"
              clearable @change="senderquery.ischange = true"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" icon="el-icon-search" circle @click="getsenderlistsdata"></el-button>
            <el-button type="danger" icon="el-icon-plus" circle @click="addsender"></el-button>
          </el-form-item>
        </el-form>
        <div class="sender-reciever-infos">
          <el-table :data="senderlists" v-loading="senderquery.loading">
            <el-table-column prop="name" label="发货人名称"></el-table-column>
            <el-table-column prop="phone" label="手机号" align="center" width="180"></el-table-column>
            <el-table-column label="地址" align="left" width="300">
              <template slot-scope="scope">
                <span style="float:left;width:100%">{{ scope.row.province }}-{{ scope.row.city }}-{{ scope.row.area
                  }}</span>
                <span style="float:left;width:100%">{{ scope.row.address }}</span>
              </template>
            </el-table-column>
            <el-table-column label="操作" align="center" width="140">
              <template slot-scope="scope">
                <el-button type="success" size="mini" icon="el-icon-check" circle @click="selectsender(scope.row)"
                  v-if="issenderselect"></el-button>
                <el-button type="warning" size="mini" icon="el-icon-edit" circle
                  @click="editsender(scope.row)"></el-button>
                <el-button type="danger" size="mini" icon="el-icon-delete" circle
                  @click="delsender(scope.row)"></el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="block">
          <!--分页begin-->
          <el-pagination @size-change="senderpageSizeChange" @current-change="senderpageCurrentChange"
            :current-page="senderquery.p" :page-sizes="[10, 20, 50]" :page-size="senderquery.rollpage"
            layout="total, sizes, prev, pager, next, jumper" :total="senderrows">
          </el-pagination>
          <!--分页end-->
        </div>
      </el-dialog>

      <!-- 新增 / 编辑寄件人 -->
      <el-dialog title="新增/编辑寄件人信息" :visible.sync="addsenderDialog" width="30%" top="10vh">
        <el-form :inline="true" class="demo-form-inline" size="mini">
          <el-form-item label="寄件人" label-width="120">
            <el-input placeholder="请输入关键字" v-model="addsenderquery.name" clearable></el-input>
          </el-form-item>
          <el-form-item label="手机号" label-width="120">
            <el-input placeholder="请输入关键字" v-model="addsenderquery.phone" clearable></el-input>
          </el-form-item>
          <el-form-item label="所在省份：" label-width="120">
            <el-select v-model="addsenderquery.provinceid" clearable remote filterable placeholder="请选择省份"
              @change="changeprovince">
              <el-option v-for="(item, index) in provincelists" :label="item.showlable" :value="item.id" :key="index">
                <span style="float: right; color: #C0C4CC; font-size: 13px">{{ item.py }}</span>
                <span style="float: left">{{ item.name }}</span>
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="所在城市：" label-width="120" v-if="citylists.length > 0">
            <el-select v-model="addsenderquery.cityid" clearable remote filterable placeholder="请选择城市"
              @change="changecity">
              <el-option v-for="(item, index) in citylists" :label="item.showlable" :value="item.id" :key="index">
                <span style="float: right; color: #C0C4CC; font-size: 13px">{{ item.py }}</span>
                <span style="float: left">{{ item.name }}</span>
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="所在区域/县：" label-width="120" v-if="arealists.length > 0">
            <el-select v-model="addsenderquery.areaid" clearable remote filterable placeholder="请选择区域/县"
              @change="changearea">
              <el-option v-for="(item, index) in arealists" :label="item.showlable" :value="item.id" :key="index">
                <span style="float: right; color: #C0C4CC; font-size: 13px">{{ item.py }}</span>
                <span style="float: left">{{ item.name }}</span>
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="详细地址" label-width="120">
            <el-input placeholder="请输入详细地址" v-model="addsenderquery.address" clearable></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button size="small" @click="addsenderDialog = false">取 消</el-button>
          <el-button size="small" type="primary" @click="saveaddsender">保 存</el-button>
        </div>
      </el-dialog>

      <!-- 查看收件人 -->
      <el-dialog title="查看收货人信息" :visible.sync="recieverDialog" width="55%" top="10vh">
        <el-form :inline="true" class="demo-form-inline" size="mini">
          <el-form-item>
            <el-input placeholder="请输入关键字" v-model="recieverquery.key"
              @keyup.enter.native.prevent="getrecieverlistsdata" clearable
              @change="recieverquery.ischange = true"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" icon="el-icon-search" circle @click="getrecieverlistsdata"></el-button>
            <el-button type="danger" icon="el-icon-plus" circle @click="addreciever"></el-button>
          </el-form-item>
        </el-form>
        <div class="sender-reciever-infos">
          <el-table :data="recieverlists" v-loading="recieverquery.loading">
            <el-table-column prop="name" label="发货人名称"></el-table-column>
            <el-table-column prop="phone" label="手机号" align="center" width="180"></el-table-column>
            <el-table-column label="地址" align="left" width="280">
              <template slot-scope="scope">
                <span style="float:left;width:100%">{{ scope.row.province }}-{{ scope.row.city }}-{{ scope.row.area
                  }}</span>
                <span style="float:left;width:100%">{{ scope.row.address }}</span>
              </template>
            </el-table-column>
            <el-table-column label="操作" align="center" width="140">
              <template slot-scope="scope">
                <el-button type="success" size="mini" icon="el-icon-check" circle @click="selectreciever(scope.row)"
                  v-if="isrecieverselect"></el-button>
                <el-button type="warning" size="mini" icon="el-icon-edit" circle
                  @click="editreciever(scope.row)"></el-button>
                <el-button type="danger" size="mini" icon="el-icon-delete" circle
                  @click="delreciever(scope.row)"></el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="block">
          <!--分页begin-->
          <el-pagination @size-change="recieverpageSizeChange" @current-change="recieverpageCurrentChange"
            :current-page="recieverquery.p" :page-sizes="[10, 20, 50]" :page-size="recieverquery.rollpage"
            layout="total, sizes, prev, pager, next, jumper" :total="recieverrows">
          </el-pagination>
          <!--分页end-->
        </div>
      </el-dialog>

      <!-- 新增 / 编辑寄件人 -->
      <el-dialog title="新增/编辑收件人信息" :visible.sync="addrecieverDialog" width="30%" top="10vh">
        <el-form :inline="true" class="demo-form-inline" size="mini">
          <el-form-item label="收件人" label-width="120">
            <el-input placeholder="请输入关键字" v-model="addrecieverquery.name" clearable></el-input>
          </el-form-item>
          <el-form-item label="手机号" label-width="120">
            <el-input placeholder="请输入关键字" v-model="addrecieverquery.phone" clearable></el-input>
          </el-form-item>
          <el-form-item label="所在省份：" label-width="120">
            <el-select v-model="addrecieverquery.provinceid" clearable remote filterable placeholder="请选择省份"
              @change="changeprovince">
              <el-option v-for="(item, index) in provincelists" :label="item.showlable" :value="item.id" :key="index">
                <span style="float: right; color: #C0C4CC; font-size: 13px">{{ item.py }}</span>
                <span style="float: left">{{ item.name }}</span>
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="所在城市：" label-width="120" v-if="citylists.length > 0">
            <el-select v-model="addrecieverquery.cityid" clearable remote filterable placeholder="请选择城市"
              @change="changecity">
              <el-option v-for="(item, index) in citylists" :label="item.showlable" :value="item.id" :key="index">
                <span style="float: right; color: #C0C4CC; font-size: 13px">{{ item.py }}</span>
                <span style="float: left">{{ item.name }}</span>
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="所在区域/县：" label-width="120" v-if="arealists.length > 0">
            <el-select v-model="addrecieverquery.areaid" clearable remote filterable placeholder="请选择区域/县"
              @change="changearea">
              <el-option v-for="(item, index) in arealists" :label="item.showlable" :value="item.id" :key="index">
                <span style="float: right; color: #C0C4CC; font-size: 13px">{{ item.py }}</span>
                <span style="float: left">{{ item.name }}</span>
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="详细地址" label-width="120">
            <el-input placeholder="请输入详细地址" v-model="addrecieverquery.address" clearable></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button size="small" @click="addrecieverDialog = false">取 消</el-button>
          <el-button size="small" type="primary" @click="saveaddreciever">保 存</el-button>
        </div>
      </el-dialog>

      <!-- 查看物流信息 -->
      <el-dialog :title="logisticsDetailsTitle" :visible.sync="logisticsDetailsVisible" width="50%" top="10vh">
        <Timeline :items="timelineItems" />
      </el-dialog>

      <!-- 选择销售单 -->
      <!-- <el-dialog title="获取销售单信息" :visible.sync="sellDialog" width="50%" top="10vh">
        <el-form :inline="true" class="demo-form-inline" size="mini">
          <el-form-item style="width:20%">
            <el-select v-model="sellquery.type" @change="changeselltype">
              <el-option v-for="(item, index) in fromlists" :label="item.name" :value="item.id" :key="index"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item style="width:20%" v-if="sellquery.type == 1">
            <el-select v-model="sellquery.paytype" clearable @change="sellquery.ischange = true">
              <el-option v-for="(item, index) in paytypelists" :label="item.name" :value="item.id"
                :key="index"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-input placeholder="请输入关键字" v-model="sellquery.key" clearable @change="sellquery.ischange = true"
              @keyup.enter.native.prevent="selldatalists"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" size="mini" icon="el-icon-search" circle @click="selldatalists"></el-button>
          </el-form-item>
        </el-form>
        <div class="sell-select-goodslists">
          <el-tag class="sell-select-detail" v-for="(item, index) in selltemps" :key="index" type="danger" size="small"
            effect="dark" closable @close="closeselltemp(index)">{{ item.documents }}</el-tag>
        </div>
        <div class="sender-reciever-infos">
          <el-table ref="multipleTable" :data="selllists" v-loading="sellquery.loading" @row-click="rowclick"
            @select="handleSelectsingle" @select-all="handleSelectall">
            <el-table-column type="selection" width="50"></el-table-column>
            <el-table-column prop="id" label="id"></el-table-column>
            <el-table-column label="销售单号" align="center" width="180">
              <template slot-scope="scope">
                <span>
                  {{ scope.row.documents }}
                  <i style="font-style:normal;font-size:12px;line-height:12px;color:#fff;padding:2px 5px;border-radius:5px;background:#909399"
                    v-if="scope.row.orderfrom == 0 && scope.row.paytype == 0">线下</i>
                  <i style="font-style:normal;font-size:12px;line-height:12px;color:#fff;padding:2px 5px;border-radius:5px;background:#F56C6C"
                    v-if="scope.row.orderfrom == 0 && scope.row.paytype == 1">商城</i>
                  <i style="font-style:normal;font-size:12px;line-height:12px;color:#fff;padding:2px 5px;border-radius:5px;background:#E6A23C"
                    v-if="scope.row.orderfrom == 0 && scope.row.paytype == 3">跑店</i>
                  <i style="font-style:normal;font-size:12px;line-height:12px;color:#fff;padding:2px 5px;border-radius:5px;background:#67C23A"
                    v-if="scope.row.orderfrom == 0 && scope.row.paytype == 4">分销</i>
                  <i style="font-style:normal;font-size:12px;line-height:12px;color:#fff;padding:2px 5px;border-radius:5px;background:#67C23A"
                    v-if="scope.row.orderfrom == 0 && scope.row.paytype == 6">邀请有礼</i>
                  <i style="font-style:normal;font-size:12px;line-height:12px;color:#fff;padding:2px 5px;border-radius:5px;background:#909399"
                    v-if="scope.row.orderfrom == 1">有贝</i>
                </span>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="block">
          <el-pagination @size-change="sellpageSizeChange" @current-change="sellpageCurrentChange"
            :current-page="sellquery.p" :page-sizes="[10, 20, 50]" :page-size="sellquery.rollpage"
            layout="total, sizes, prev, pager, next, jumper" :total="sellrows">
          </el-pagination>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button size="small" @click="sellDialog = false">取 消</el-button>
          <el-button size="small" type="primary" @click="savesells">保 存</el-button>
        </div>
      </el-dialog> -->


      <!-- 新增 / 编辑快递单信息 -->
      <!-- <el-dialog title="新增/编辑快递信息" :visible.sync="addlogisticsDialog" width="80%" top="10vh">
        <div class="sell-shipping-birld">
          <div class="sell-shipping-left" v-loading="addlogisticsquery.loading">
            <div class="sell-shipping-left-title">
              <span>销售单信息<i>（当前添加订单数：{{ addlogisticsquery.sells.length }}）</i></span>
              <el-button type="danger" size="mini" circle icon="el-icon-plus" style="float:right"
                @click="getsellers"></el-button>
            </div>
            <ul>
              <li v-for="(item, index) in addlogisticsquery.sells" :key="index">
                <div class="sell-shipping-documents">
                  {{ item.documents }}（
                  <span v-if="item.orderfrom == 0 && item.paytype == 0">线下</span>
                  <span v-if="item.orderfrom == 0 && item.paytype == 1">商城</span>
                  <span v-if="item.orderfrom == 0 && item.paytype == 3">跑店</span>
                  <span v-if="item.orderfrom == 0 && item.paytype == 4">分销</span>
                  <span v-if="item.orderfrom == 0 && item.paytype == 6">邀请有礼</span>
                  <span v-if="item.orderfrom == 1">有贝</span>
                  ，id：{{ item.sellid }}）
                </div>
                <el-button type="danger" size="mini" circle icon="el-icon-delete" style="float:right"
                  @click="delsells(item)"></el-button>
              </li>
            </ul>
          </div>
          <div class="sell-shipping-right" v-loading="addlogisticsquery.loading">
            <div class="sell-shipping-right-title">
              <span>快递单信息<i>（当前添加快递单数：{{ addlogisticsquery.shippings.length }}）</i></span>
              <el-button type="danger" size="mini" circle icon="el-icon-plus" style="float:right"
                @click="addlogistics"></el-button>
            </div>
            <ul>
              <li v-for="(item, index) in addlogisticsquery.shippings" :key="index">
                <a @click="selectshippings(index)">
                  <div class="shippingmessage">
                    <span>{{ item.logisticsname == '' ? '' : item.logisticsname + '：' }}{{ item.code == '' ? '' :
                      item.code}}</span>
                    <el-button type="danger" size="mini" circle icon="el-icon-delete" style="float:right"
                      @click="delshippings(item, index)"></el-button>
                    <el-tooltip class="item" effect="dark" :content="item.status == 1 ? '该快递单信息已提交至快递鸟' : '将快递单信息提交至快递鸟'"
                      placement="top">
                      <el-button :type="item.status == 1 ? 'info' : 'warning'" size="mini" circle icon="el-icon-check"
                        style="float:right" @click="submitshippingtobirld(item)"></el-button>
                    </el-tooltip>
                  </div>
                  <div class="shippingmessage-content">
                    <div>
                      <span style="float:left;width:40%">重量（kg）：</span>
                      <div style="float:left;width:60%"><el-input size="mini" v-model="item.weight"
                          @blur="changeshippingweight(item.id, item.weight)" /></div>
                    </div>
                    <span>收件人：{{ item.recievename }}</span>
                    <span>收件人电话：{{ item.recievephone }}</span>
                    <span>
                      收件人地址：
                      {{ item.recieveProvincename == '' ? '' : item.recieveProvincename + '-' }}
                      {{ item.recieveCityname == '' ? '' : item.recieveCityname + '-' }}
                      {{ item.recieveArea == '' ? '' : item.recieveArea }}
                    </span>
                  </div>
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div class="sell-shipping-content-alls">
          <div class="sell-shipping-all-left" v-loading="addlogisticsquery.loading1">
            <div class="sell-shipping-all-left-title">
              <span>销售单商品信息<i>（当前剩余未分配商品数：{{ sellgoodsnums }}）</i></span>
            </div>
            <div class="sell-shipping-all-left-contents">
              <ul v-for="(e, i) in addlogisticsquery.sells" :key="i">
                <li v-for="(ee, ii) in e.goods" :key="ii">
                  <div class="sell-shipping-all-left-goods">
                    <span class="documents">
                      {{ e.documents }}（
                      <em v-if="e.orderfrom == 0 && e.paytype == 0">线下</em>
                      <em v-if="e.orderfrom == 0 && e.paytype == 1">商城</em>
                      <em v-if="e.orderfrom == 0 && e.paytype == 3">跑店</em>
                      <em v-if="e.orderfrom == 0 && e.paytype == 4">分销</em>
                      <em v-if="e.orderfrom == 0 && e.paytype == 6">邀请有礼</em>
                      <em v-if="e.orderfrom == 1">有贝</em>
                      ，id:{{ e.sellid }}，did:{{ ee.selldetailid }}）
                    </span>
                    <el-tooltip class="item" effect="dark" :content="'（' + ee.type + '）' + ee.productname"
                      placement="top-start">
                      <span class="goods"><i>{{ ee.type }}</i>{{ ee.productname }}</span>
                    </el-tooltip>
                  </div>
                  <el-button type="success" circle size="mini" icon="el-icon-arrow-right"
                    style="float:right;margin-top:10px" @click="matchgoodstosell(i, ii)"></el-button>
                </li>
              </ul>
            </div>
          </div>

          <div class="sell-shipping-all-right" v-if="addlogisticsquery.clickshippingindex >= 0"
            v-loading="addlogisticsquery.loading1">
            <div class="sell-shipping-all-right-title">
              <span>快递单信息详情</span>
            </div>
            <div class="sell-shipping-all-right-content">
              <div class="sell-shipping-all-right-base">
                <div class="sell-shipping-all-right-one">快递信息</div>
                <div class="sell-shipping-all-right-two">
                  {{ addlogisticsquery.localshippings.logisticsname == '' ? '' :
                    addlogisticsquery.localshippings.logisticsname}}
                  {{ addlogisticsquery.localshippings.logisticscode == '' ? '' :
                    "（" + addlogisticsquery.localshippings.logisticscode+"）："}}
                  {{ addlogisticsquery.localshippings.code == '' ? '' : addlogisticsquery.localshippings.code }}
                </div>
                <div class="sell-shipping-all-right-three">
                </div>
              </div>
              <div class="sell-shipping-all-right-base1">
                <div class="sell-shipping-all-right-one1">发件人信息</div>
                <div class="sell-shipping-all-right-two1">
                  <span>
                    {{ addlogisticsquery.localshippings.sendname == '' ? '' :
                      addlogisticsquery.localshippings.sendname+'-'}}
                    {{ addlogisticsquery.localshippings.sendphone == '' ? '' : addlogisticsquery.localshippings.sendphone }}
                  </span>
                  <span>
                    {{ addlogisticsquery.localshippings.sendProvincename == '' ? '' :
                      addlogisticsquery.localshippings.sendProvincename+'-'}}
                    {{ addlogisticsquery.localshippings.sendCityname == '' ? '' :
                      addlogisticsquery.localshippings.sendCityname+'-'}}
                    {{ addlogisticsquery.localshippings.sendArea == '' ? '' : addlogisticsquery.localshippings.sendArea }}
                  </span>
                  <span>{{ addlogisticsquery.localshippings.sendAddress }}</span>
                </div>
                <div class="sell-shipping-all-right-three1">
                  <el-button type="primary" icon="el-icon-search" size="mini" circle
                    @click="shippinggetsender"></el-button>
                </div>
                <div class="sell-shipping-all-right-fourth1">
                  <el-input v-model="sendermatchaddress" @blur="matchaddress(1)"
                    placeholder="（智能识别模板）发货地址：上海 上海市 嘉定区，详细地址：上海市嘉定区外冈镇西冈身路282号，发货人：陈明生，发货电话：16602188303"
                    type="textarea" :rows="2" />
                </div>
              </div>
              <div class="sell-shipping-all-right-base1">
                <div class="sell-shipping-all-right-one1">收件人信息</div>
                <div class="sell-shipping-all-right-two1">
                  <span>
                    {{ addlogisticsquery.localshippings.recievename == '' ? '' :
                      addlogisticsquery.localshippings.recievename+'-'}}
                    {{ addlogisticsquery.localshippings.recievephone == '' ? '' :
                      addlogisticsquery.localshippings.recievephone}}
                  </span>
                  <span>
                    {{ addlogisticsquery.localshippings.recieveProvincename == '' ? '' :
                      addlogisticsquery.localshippings.recieveProvincename+'-'}}
                    {{ addlogisticsquery.localshippings.recieveCityname == '' ? '' :
                      addlogisticsquery.localshippings.recieveCityname+'-'}}
                    {{ addlogisticsquery.localshippings.recieveArea == '' ? '' :
                      addlogisticsquery.localshippings.recieveArea}}
                  </span>
                  <span>{{ addlogisticsquery.localshippings.recieveAddress }}</span>
                </div>
                <div class="sell-shipping-all-right-three1">
                  <el-button type="primary" icon="el-icon-search" size="mini" circle
                    @click="shippinggetreciever"></el-button>
                </div>
                <div class="sell-shipping-all-right-fourth1">
                  <el-input v-model="receivermatchaddress" @blur="matchaddress(2)"
                    placeholder="（智能识别模板）收货地址：上海 上海市 嘉定区，详细地址：上海市嘉定区外冈镇西冈身路282号，收货人：陈明生，发货电话：16602188303"
                    type="textarea" :rows="2" />
                </div>
              </div>

              <div class="sell-shipping-all-right-goodsinfos">
                <ul>
                  <li v-for="(item, index) in addlogisticsquery.localshippings.goods" :key="index">
                    <div class="sell-shipping-all-right-goods">
                      <span
                        class="documents">{{ item.documents }}（{{ item.paytype }}，id:{{ item.sellid }}，did:{{ item.selldetailid }}）</span>
                      <el-tooltip class="item" effect="dark" :content="'（' + item.type + '）' + item.productname"
                        placement="top-start">
                        <span class="goods"><i>{{ item.type }}</i>{{ item.productname }}</span>
                      </el-tooltip>
                    </div>
                    <el-button type="success" circle size="mini" icon="el-icon-arrow-left"
                      @click="rollbackgoods(item, index)"
                      style="float:right;margin-top:10px;margin-right:10px"></el-button>
                  </li>
                </ul>
              </div>

            </div>

          </div>
        </div>

        <div slot="footer" class="dialog-footer">
          <el-button size="small" @click="addlogisticsDialog = false">取 消</el-button>
        </div>
      </el-dialog> -->


      <!-- 快递电子面单打印 -->
      <!--
	  <el-dialog title="电子面单打印模板" :visible.sync="printDialog" top="10vh">
			<div id="shippingprinttemp" class="shippingprinttemp" v-for="(item,index) in printerlists" :key="index" style="margin-bottom:20px" @click="selectprints(item)">
				<div><el-checkbox v-model="item.check"></el-checkbox></div>
                <div style="width:100%;height:20px"><img src="../../assets/bskd.jpg" style="float:left;width:39%"/></div>
				<div class="printtime">{{item.localtime}}</div>
				<div class="codeout"><img :id="item.bacodeid" style="float:left;width:60%;margin-left:20%;padding:5px 0"/></div>
				<div class="sourse">
					<span class="sourse-left">{{item.OriginCode}}</span>
					<span class="sourse-right">{{item.SortingCode}}</span>
				</div>
				<div class="sourse">
					<span class="sourse-left">集</span>
					<span class="sourse-right">{{item.PackageCode}}</span>
				</div>
				<div class="shippingsender">
					<div class="senderlogo">收</div>
					<div class="senderright">
						<span class="sendername">{{item.recievename}}</span>
						<span class="senderphone">{{item.recievephone}}</span>
						<span class="senderaddress">{{item.recieveProvincename}} {{item.recieveCityname}} {{item.recieveArea}} {{item.recieveAddress}}</span>
					</div>
				</div>
				<div class="shippingreciever">
					<div class="recieverleft">
						<div class="recieverlogo">寄</div>
						<span class="recievername">***</span>
						<span class="recieverphone">{{item.sendphone}}</span>
					</div>
					<div class="recievercenter">
						<div class="ercode" :id="item.ercodeid" ref="ercodeinfos" ></div>
					</div>
					<div class="recieverright">
						<div class="recieverrighttop">
							<span>已验视</span>
							<span>已安检</span>
						</div>
						<div class="recieverrightbottom">
							<span>签字栏</span>
						</div>
					</div>
				</div>
			</div>
            <img id="yyy" style="float:left;width:60%;margin-left:20%;padding:5px 0"/>
			<div slot="footer" class="dialog-footer">
              <el-button size="small" @click="printDialog = false">取 消</el-button>
              <el-button size="small" type="primary" @click="printlocalpage">确 定</el-button>
          	</div>
		</el-dialog>
        -->


      <!-- 快递电子面单打印 -->
      <!-- <el-dialog title="电子面单打印模板" :visible.sync="printDialog" top="10vh">
        <div id="shippingprinttemp" class="shippingprinttemp" v-for="(item, index) in printerlists" :key="index"
          style="margin-bottom:20px" @click="selectprints(item)">
          <div><el-checkbox v-model="item.check"></el-checkbox></div>
          <div style="width:100%;height:20px"></div>
          <div class="printtime">{{ item.localtime }}</div>
          <div class="MarkDestination">{{ item.MarkDestination }}</div>
          <div class="codeout"><img :id="item.bacodeid"
              style="float:left;width:80%;margin-left:10%;padding:5px 0 10px 0" />
          </div>
          <div class="infomain">
            <div class="left">
              <span class="packagename">{{ item.PackageName }}</span>
              <div class="sender">
                <div class="senderlogo"><span>收</span></div>
                <div class="sendercontent">
                  <span class="sendername">{{ item.recievename }}</span>
                  <span class="senderphone">{{ item.recievephone }}</span>
                  <span class="sendercity">{{ item.recieveProvincename }} {{ item.recieveCityname }} {{ item.recieveArea }}
                    {{ item.recieveAddress }}</span>
                </div>
              </div>
              <div class="reciever">
                <div class="recieverlogo"><span>寄</span></div>
                <div class="recievercontent">
                  <span class="recievername">***</span>
                  <span class="recieverphone">{{ item.sendphone }}</span>
                  <span class="recievercity">{{ item.sendProvincename }} {{ item.sendCityname }} {{ item.sendArea }}
                    {{ item.sendAddress }}</span>
                </div>
              </div>
              <div class="shippingbotton">
                <div class="ercode" :id="item.ercodeid" ref="ercodeinfos"></div>
                <div class="notice">本次服务适用中通官网(www.zto.com)公示的快递服务协议条款。您对此单的签收代表您已收到快件且包装完好无损。</div>
                <div class="sign">签收人 / 时间</div>
                <div class="note">95720-中通快递员专属外呼号码<i>已验视</i><i>已实名</i></div>
              </div>
            </div>
            <div class="right"></div>
          </div>

        </div>
        <img id="yyy" style="float:left;width:60%;margin-left:20%;padding:5px 0" />
        <div slot="footer" class="dialog-footer">
          <el-button size="small" @click="printDialog = false">取 消</el-button>
          <el-button size="small" type="primary" @click="printlocalpage">确 定</el-button>
        </div>
      </el-dialog> -->


      <!-- 快递电子面单打印模板界面 -->
      <!-- <el-dialog title="电子面单打印模板" :visible.sync="printendsDialog" top="10vh">
        <div id="shippingprintend">
          <div id="shippingprinttemp" class="shippingprinttemp" v-for="(item, index) in printerlists" v-if="item.check"
            :key="index" style="margin-bottom:20px">
            <div id="">
              <div style="width:100%;height:30px"></div>
              <div class="printtime">{{ item.localtime }}</div>
              <div class="MarkDestination">{{ item.MarkDestination }}</div>
              <div class="codeout"><img :id="item.bacodeendid"
                  style="float:left;width:80%;margin-left:10%;padding:5px 0 10px 0" /></div>
              <div class="infomain">
                <div class="left">
                  <span class="packagename">{{ item.PackageName }}</span>
                  <div class="sender">
                    <div class="senderlogo"><span>收</span></div>
                    <div class="sendercontent">
                      <span class="sendername">{{ item.recievename }}</span>
                      <span class="senderphone">{{ item.recievephone }}</span>
                      <span class="sendercity">{{ item.recieveProvincename }} {{ item.recieveCityname }}
                        {{ item.recieveArea }}
                        {{ item.recieveAddress }}</span>
                    </div>
                  </div>
                  <div class="reciever">
                    <div class="recieverlogo"><span>寄</span></div>
                    <div class="recievercontent">
                      <span class="recievername">***</span>
                      <span class="recieverphone">{{ item.sendphone }}</span>
                      <span class="recievercity">{{ item.sendProvincename }} {{ item.sendCityname }} {{ item.sendArea }}
                        {{ item.sendAddress }}</span>
                    </div>
                  </div>
                  <div class="shippingbotton">
                    <div class="ercode" :id="item.ercodeendid" ref="ercodeinfos"></div>
                    <div class="notice">本次服务适用中通官网(www.zto.com)公示的快递服务协议条款。您对此单的签收代表您已收到快件且包装完好无损。</div>
                    <div class="sign">签收人 / 时间</div>
                    <div class="note">95720-中通快递员专属外呼号码<i>已验视</i><i>已实名</i></div>
                  </div>
                </div>
                <div class="right"></div>
              </div>
            </div>
          </div>
        </div>
      </el-dialog> -->






    </div>
  </transition>
</template>

<script>
import QRCode from 'qrcodejs2'
import Timeline from '../base/Timeline.vue';
import md5 from '@/assets/md5/md52.js'
import Base64 from '@/assets/md5/base64.js'
export default {
  props: ['childdata'],
  components: { QRCode },
  components: { Timeline },
  data() {
    return {
      timelineItems: [],
      logisticsList: [],
      url: this.GLOBAL.domain + "/Sellshippingbirld/index",
      transitionshow: true,
      actionauth: [],
      query: {
        act: 'generate_waybill_list',
        token: this.$cookies.get('token'),
        loading: false,
        ischange: false,
        date: [],
        start_time: '',
        end_time: '',
        express_id: '',
        documents: '',
        // keytype: 1,
        // key: '',
        p: 1,
        rollpage: 10
      },
      printrows: 0,
      printlists: [],
      keytypelists: [
        { id: 1, name: '按打印单号搜索关键字' },
        { id: 2, name: '按销售出库单号搜索关键字' },
        { id: 3, name: '按销物流单号搜索关键字' },
      ],

      provincequery: {
        act: 'getjdcityinfos',
        token: this.$cookies.get('token'),
      },
      provincelists: [],
      cityquery: {
        act: 'getjdcityinfos',
        token: this.$cookies.get('token'),
        parentid: '',
      },
      citylists: [],
      areaquery: {
        act: 'getjdcityinfos',
        token: this.$cookies.get('token'),
        parentid: '',
      },
      arealists: [],
      shipDialog: false,
      shiploading: false,
      shippinglists: [],

      senderDialog: false,
      issenderselect: false,
      senderquery: {
        act: 'getsenderlists',
        token: this.$cookies.get('token'),
        loading: false,
        ischange: false,
        key: '',
        p: 1,
        rollpage: 10,
      },
      senderlists: [],
      senderrows: 0,

      addsenderDialog: false,
      addsenderquery: {
        act: 'addsender',
        token: this.$cookies.get('token'),
        id: '',
        name: '',
        phone: '',
        provinceid: '',
        cityid: '',
        areaid: '',
        address: '',
      },

      recieverDialog: false,
      isrecieverselect: false,
      recieverquery: {
        act: 'getrecieverlists',
        token: this.$cookies.get('token'),
        loading: false,
        ischange: false,
        key: '',
        p: 1,
        rollpage: 10,
      },
      recieverlists: [],
      recieverrows: 0,
      addrecieverDialog: false,
      addrecieverquery: {
        act: 'addreciever',
        token: this.$cookies.get('token'),
        id: '',
        name: '',
        phone: '',
        provinceid: '',
        cityid: '',
        areaid: '',
        address: '',
      },

      addlogisticsDialog: false,
      addlogisticsquery: {
        act: 'addlogistics',
        token: this.$cookies.get('token'),
        id: '',
        sells: [
          { sellid: '', documents: '', paytype: '', goods: [{ selldetailid: '', productid: '', productname: '', num: '', unit: '', type: '', isshow: true }] }
        ],
        shippings: [
          {
            sordesc: '', logisticsid: '', logisticsname: '', logisticscode: '', code: '', status: '',
            senderid: '', sendname: '', sendphone: '', sendProvincename: '', sendCityname: '', sendArea: '', sendAddress: '',
            recieverid: '', recievename: '', recievephone: '', recieveProvincename: '', recieveCityname: '', recieveArea: '', recieveAddress: '',
            goods: [{ sellid: '', documents: '', paytype: '', selldetailid: '', productid: '', productname: '', num: '', unit: '', type: '' }]
          }
        ],
        clickshippingindex: -1,
        localshippings: {
          sordesc: '', logisticsid: '', logisticsname: '', logisticscode: '', code: '', senderid: '', sendname: '', sendphone: '',
          sendProvincename: '', sendCityname: '', sendArea: '', sendAddress: '', recieverid: '', recievename: '',
          recievephone: '', recieveProvincename: '', recieveCityname: '', recieveArea: '', recieveAddress: '',
          goods: [{ sellid: '', documents: '', paytype: '', selldetailid: '', productid: '', productname: '', num: '', unit: '', type: '' }]
        },
        loading: false,
        loading1: false,
      },
      sorts: 0,
      sellgoodsnums: 0,

      searchgoodsquery: {
        key: '',
        alls: false,
      },

      sellDialog: false,
      sellquery: {
        act: 'getselllists',
        token: this.$cookies.get('token'),
        type: 1,
        paytype: '',
        key: '',
        p: 1,
        rollpage: 10,
        loading: false,
        ischange: false,
      },
      fromlists: [{ id: 1, name: '宠赞订单' }, { id: 2, name: '有贝订单' }],
      selllists: [],
      sellrows: 0,
      paytypelists: [
        { id: 1, name: '线下订单' },
        { id: 2, name: '商城订单' },
        { id: 3, name: '跑店订单' },
        { id: 4, name: '分销订单' },
        { id: 6, name: '邀请有礼' },
      ],
      selltemps: [],
      printerlists: [],
      printDialog: false,
      printendsDialog: false,
      sendermatchaddress: '',
      receivermatchaddress: '',
      logisticsDetailsVisible: false,
      logisticsDetailsTitle: "",
      allSelection: []
    }
  },

  watch: {
    childdata(val) {
      if (val.sellid) { //已打开窗口，再次点击传递数据
        this.getprintsingle(val.sellid, val.type, val.documents);
      }
    }
  },


  mounted() {
    this.getactionauth(); //获取权限设置
    this.getallshippinglists(); //获取可用的快递信息
    this.getsenderlistsdata(); //获取发件人信息

    if (this.childdata.sellid > 0) { //点击带参数跳转，精确定位展示数据
      this.getprintsingle(this.childdata.sellid, val.type, val.documents);
    } else { //点击不带参数跳转
      this.getprintsdata(); //获取打印单信息
    }

    // 查询快递公司
    this.$axios({
      url: this.url,
      method: 'POST',
      data: {
        act: 'choose_express_delivery',
      }
    })
      .then(res => {
        this.logisticsList = res.Data;
      })

  },


  methods: {
    handleSearch() {
      this.query.p = 1;
      this.getprintsdata()
    },
    getExpress(row) {
      // 这里添加获取面单的逻辑
      this.$axios({
        url: this.url,
        method: 'POST',
        data: {
          act: 'place_order_waybill',
          id: row.id
        }
      })
        .then(res => {
          this.getprintsdata()
          this.$message.success('获取面单成功!');
        })
    },
    recycleExpress(row) {
      // 添加确认提示
      this.$confirm('是否回收该快递单号?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        // 用户点击确定后执行回收逻辑
        this.$axios({
          url: this.url,
          method: 'POST',
          data: {
            act: 'cancel_the_waybill',
            id: row.id
          }
        })
          .then(res => {
            this.getprintsdata();
            this.$message.success('回收面单成功!');
          })
      })
    },
    openExpressStatistics() {
      this.$emit('listenchild', { name: '快递面单统计', url: 'expressStatistics', data: { sellid: 0 } });
    },
    showLogisticsDetails(row) {
      this.$axios({
        url: '/Sellshippingbirld/index',
        method: 'POST',
        data: {
          act: 'generate_waybill_Logistics',
          id: row.id
        }
      })
        .then(res => {
          this.logisticsDetailsTitle = `${res.Data.name} | ${res.Data.documents}`
          this.timelineItems = res.Data.lists.map(item => {
            return {
              title: item.msgTime,
              content: item.content
            }
          })
          this.logisticsDetailsVisible = true
        })
    },

    /** 获取操作功能权限 **/
    getactionauth() {
      var data = this.$cookies.get('actionauth');
      data = JSON.parse(data);
      this.actionauth = data;
    },


    /** 单个销售单异步点击跳转打印快递信息 **/
    getprintsingle(sellid, type, documents) {
      this.query.loading = true;
      var resource = this.$resource(this.url);
      resource.query({ act: 'getsellprintinfos', sellid: sellid, type: type ? type : 0, documents: documents ? documents : '', token: this.$cookies.get('token') }).then((res) => {
        if (res.data.Result > 0) {
          if (res.data.Result == '70001') this.$router.push('/login')
          this.$message.error(res.data.Message);
          this.query.loading = false;
        } else {
          var result = JSON.parse(Base64.decode(res.data.Data));
          this.query.loading = false;
          //精确定位搜索条件
          this.query.ischange = false;
          this.query.date = [];
          this.query.keytype = 2;
          this.query.key = result.documents;
          this.query.p = 1;
          this.query.rollpage = 10;
          this.getprintsdata(); //获取打印单信息
          //精确获取搜索详情
          this.getshippinglogistics(result); //精确获取搜索详情
        }
      }).catch((res) => {
        this.query.loading = false;
      });


    },

    handleSelectionChange(selection) {
      this.allSelection = selection
    },


    /** 获取单列表信息 **/
    getprintsdata() {
      this.query.loading = true;
      if (this.query.date && this.query.date.length) {
        this.query.start_time = this.query.date[0];
        this.query.end_time = this.query.date[1];
      } else {
        this.query.start_time = '';
        this.query.end_time = '';
      }

      var resource = this.$resource(this.url);
      resource.save(this.query).then((res) => {
        if (res.data.Result > 0) {
          if (res.data.Result == '70001') this.$router.push('/login')
          this.$message.error(res.data.Message);
          this.query.loading = false;
        } else {
          this.printlists = JSON.parse(Base64.decode(res.data.Data));
          this.printrows = parseInt(res.data.count);
          this.query.loading = false;
        }
      }).catch((res) => {
        this.query.loading = false;
      });
    },
    printPageSizeChange(val) {
      this.query.rollpage = val;
      this.getprintsdata();
    },
    printPageCurrentChange(val) {
      this.query.p = val;
      this.getprintsdata();
    },


    /** 获取可用的快递信息 **/
    getallshippinglists() {
      this.shipDialog = true;
      this.shiploading = true;
      var resource = this.$resource(this.GLOBAL.domain + "Order/index");
      resource.query({ act: 'getshippingfrombirld', token: this.$cookies.get('token') }).then((res) => {
        if (res.data.Result > 0) {
          if (res.data.Result == '70001') this.$router.push('/login')
          this.$message.error(res.data.Message);
          this.shiploading = false;
        } else {
          this.shippinglists = JSON.parse(Base64.decode(res.data.Data));
          this.shiploading = false;
        }
      }).catch((res) => {
        this.shiploading = false;
      });
    },


    /** 获取销售订单信息列表 **/
    getsellers() {
      this.sellquery.paytype = '';
      this.sellquery.key = '';
      this.sellquery.p = 1;
      this.sellquery.rollpage = 10;
      this.sellDialog = true;
      this.selltemps = [];
      this.selldatalists();
    },

    /** 获取销售订单信息数据 **/
    selldatalists() {
      this.sellquery.loading = true;
      if (this.sellquery.ischange) {
        this.sellquery.p = 1;
        this.sellquery.rollpage = 10;
      }

      var resource = this.$resource(this.url);
      resource.save(this.sellquery).then((res) => {
        if (res.data.Result > 0) {
          if (res.data.Result == '70001') this.$router.push('/login')
          this.$message.error(res.data.Message);
          this.sellquery.loading = false;
        } else {
          this.selllists = JSON.parse(Base64.decode(res.data.Data));
          this.sellrows = parseInt(res.data.count);
          this.sellquery.loading = false;
          if (this.sellquery.ischange) this.sellquery.ischange = false;

          var _this = this;
          var ids = [];
          this.selltemps.forEach(function (e, i) { ids.push(e.id); });
          setTimeout(function () {
            _this.selllists.forEach(function (item, index) {
              ids.indexOf(item.id) == -1 ? '' : _this.$refs.multipleTable.toggleRowSelection(item);
            });
          }, 100);
        }
      }).catch((res) => {
        this.sellquery.loading = false;
      });
    },
    sellpageSizeChange(val) {
      this.sellquery.rollpage = val;
      this.selldatalists();
    },
    sellpageCurrentChange(val) {
      this.sellquery.p = val;
      this.selldatalists();
    },

    /** 单行点击选择/取消销售单信息 **/
    rowclick(row, event) {
      var number = -1;
      var _this = this;
      this.selltemps.forEach(function (e, index) {
        if (e.id == row.id) number = index;
      });
      number == -1 ? this.selltemps.push(row) : this.$delete(this.selltemps, number);
      this.$refs.multipleTable.toggleRowSelection(row);
    },

    /** 点击选择/取消选择 **/
    handleSelectsingle(val, row) {
      var number = -1;
      var _this = this;
      this.selltemps.forEach(function (e, index) {
        if (e.id == row.id) number = index;
      });
      number == -1 ? this.selltemps.push(row) : this.$delete(this.selltemps, number);
    },

    /** 商品全选/全不选 **/
    handleSelectall(val) {
      var ids = [];
      var number = -1;
      var _this = this;
      if (val.length > 0) { //全选
        this.selllists.forEach(function (e, i) {
          number = -1;
          _this.selltemps.forEach(function (ee, ii) {
            if (e.id == ee.id) number = ii;
          });
          number == -1 ? _this.selltemps.push(e) : '';
        });

      } else { //全不选
        this.selllists.forEach(function (e, i) {
          number = -1;
          _this.selltemps.forEach(function (ee, ii) {
            if (e.id == ee.id) number = ii;
          });
          number == -1 ? '' : _this.$delete(_this.selltemps, number);
        });
      }
    },

    /** 剔除已选中的数据 **/
    closeselltemp(index) {
      var id = this.selltemps[index].id;
      var number = -1;
      this.selllists.forEach(function (item, index) {
        if (item.id == id) number = index;
      });
      number == -1 ? '' : this.$refs.multipleTable.toggleRowSelection(this.selllists[number]);
      this.$delete(this.selltemps, index);
    },

    /** 新增销售单信息 **/
    savesells() {
      if (this.selltemps.length == 0) { this.$message.error('请选择销售单信息'); return false; }
      var resource = this.$resource(this.url);
      var sells = '';
      sells = JSON.stringify(this.selltemps);

      resource.save({ act: 'savesells', id: this.addlogisticsquery.id, sells: sells, token: this.$cookies.get('token') }).then((res) => {
        if (res.data.Result > 0) {
          if (res.data.Result == '70001') this.$router.push('/login')
          this.$message.error(res.data.Message);
        } else {
          this.sellDialog = false;
          this.getownlogisticssells(this.addlogisticsquery.id); //获取已添加的销售单信息
        }
      }).catch((res) => {

      });
    },

    /** 删除销售单信息 **/
    delsells(item) {
      var resource = this.$resource(this.url);
      resource.save({ act: 'dellogisticssell', id: this.addlogisticsquery.id, sellid: item.sellid, orderfrom: item.orderfrom, token: this.$cookies.get('token') }).then((res) => {
        if (res.data.Result > 0) {
          if (res.data.Result == '70001') this.$router.push('/login')
          this.$message.error(res.data.Message);
        } else {
          this.getownlogisticssells(this.addlogisticsquery.id);
          this.getownlogisticsshippings(this.addlogisticsquery.id);
        }
      }).catch((res) => {

      });
    },

    /////////////////////////////////////////////////////////////////////////
    //寄件人信息

    /** 获取发件人信息 **/
    getsender() {
      this.senderDialog = true;
      this.senderquery.key = '';
      this.senderquery.p = 1;
      this.senderquery.rollpage = 10;
      this.senderlists = [];
      this.senderrows = 0;
      this.issenderselect = false;
      this.getsenderlistsdata();
    },

    //获取寄件人数据
    getsenderlistsdata() {
      this.senderquery.loading = true;
      if (this.senderquery.ischange) {
        this.senderquery.p = 1;
        this.senderquery.rollpage = 10;
      }

      var resource = this.$resource(this.GLOBAL.domain + "Order/index");
      resource.save(this.senderquery).then((res) => {
        if (res.data.Result > 0) {
          if (res.data.Result == '70001') this.$router.push('/login')
          this.$message.error(res.data.Message);
          this.senderquery.loading = false;
        } else {
          this.senderlists = JSON.parse(Base64.decode(res.data.Data));
          this.senderrows = parseInt(res.data.count);
          this.senderquery.loading = false;
          if (this.senderquery.ischange) this.senderquery.ischange = false;
        }
      }).catch((res) => {
        this.senderquery.loading = false;
      });
    },
    senderpageSizeChange(val) {
      this.senderquery.rollpage = val;
      this.getsenderlistsdata();
    },
    senderpageCurrentChange(val) {
      this.senderquery.p = val;
      this.getsenderlistsdata();
    },

    /** 删除寄件人信息 **/
    delsender(item) {
      this.$confirm('您是否需要删除该寄件人信息？', { type: 'warning' }).then(() => {
        var resource = this.$resource(this.GLOBAL.domain + "Order/index");
        resource.query({ act: 'delsender', token: this.$cookies.get('token'), id: item.id }).then((res) => {
          if (res.data.Result > 0) {
            if (res.data.Result == '70001') this.$router.push('/login')
            this.$message.error(res.data.Message);
          } else {
            this.getsenderlistsdata();
          }
        }).catch((res) => {

        });
      }).catch(() => {

      });
    },

    /** 新增寄件人 **/
    addsender() {
      this.addsenderDialog = true;
      this.addsenderquery.act = "addsender";
      this.addsenderquery.id = '';
      this.addsenderquery.name = '';
      this.addsenderquery.phone = '';
      this.addsenderquery.provinceid = '';
      this.addsenderquery.cityid = '';
      this.addsenderquery.areaid = '';
      this.addsenderquery.address = '';

      this.cityquery.parentid = '';
      this.citylists = [];
      this.areaquery.parentid = '';
      this.arealists = [];
      //获取京东省份信息
      this.getjdprovince();
    },

    /** 获取待编辑的寄件人信息 **/
    editsender(item) {
      this.addsenderDialog = true;
      this.addsenderquery.act = "editsender";
      this.addsenderquery.id = item.id;
      this.addsenderquery.name = item.name;
      this.addsenderquery.phone = item.phone;
      this.addsenderquery.provinceid = item.provinceid;

      this.addsenderquery.cityid = item.cityid == 0 ? item.areaid : item.cityid;
      this.addsenderquery.areaid = item.cityid == 0 ? '' : item.areaid;
      this.addsenderquery.address = item.address;

      this.getjdprovince();
      this.cityquery.parentid = this.addsenderquery.provinceid;
      this.getjdcity();
      this.areaquery.parentid = this.addsenderquery.cityid;
      this.getjdarea();
    },

    /** 保存寄件人信息 **/
    saveaddsender() {
      var resource = this.$resource(this.GLOBAL.domain + "Order/index");
      resource.save(this.addsenderquery).then((res) => {
        if (res.data.Result > 0) {
          if (res.data.Result == '70001') this.$router.push('/login')
          this.$message.error(res.data.Message);
        } else {
          this.addsenderDialog = false;
          this.getsenderlistsdata();
        }
      }).catch((res) => {

      });
    },

    //寄件人信息
    ///////////////////////////////////////////////////////////////////////////


    //////////////////////////////////////////////////////////////////////////
    //收件人信息

    getrecieverlists() {
      this.recieverDialog = true;
      this.recieverquery.key = '';
      this.recieverquery.loading = false;
      this.recieverquery.ischange = false;
      this.recieverquery.p = 1;
      this.recieverquery.rollpage = 10;
      this.recieverlists = [];
      this.recieverrows = 0;
      this.isrecieverselect = false;
      this.getrecieverlistsdata();
    },

    //获取收件人数据
    getrecieverlistsdata() {
      this.recieverquery.loading = true;
      if (this.recieverquery.ischange) {
        this.recieverquery.p = 1;
        this.recieverquery.rollpage = 10;
      }

      var resource = this.$resource(this.GLOBAL.domain + "Order/index");
      resource.save(this.recieverquery).then((res) => {
        if (res.data.Result > 0) {
          if (res.data.Result == '70001') this.$router.push('/login')
          this.$message.error(res.data.Message);
          this.recieverquery.loading = false;
        } else {
          this.recieverlists = JSON.parse(Base64.decode(res.data.Data));
          this.recieverrows = parseInt(res.data.count);
          this.recieverquery.loading = false;
          if (this.recieverquery.ischange) this.recieverquery.ischange = false;
        }
      }).catch((res) => {
        this.recieverquery.loading = false;
      });
    },
    recieverpageSizeChange(val) {
      this.recieverquery.rollpage = val;
      this.getrecieverlistsdata();
    },
    recieverpageCurrentChange(val) {
      this.recieverquery.p = val;
      this.getrecieverlistsdata();
    },

    /** 新增收件人信息 **/
    addreciever() {
      this.addrecieverDialog = true;
      this.addrecieverquery.act = "addreciever";
      this.addrecieverquery.id = '';
      this.addrecieverquery.name = '';
      this.addrecieverquery.phone = '';
      this.addrecieverquery.provinceid = '';
      this.addrecieverquery.cityid = '';
      this.addrecieverquery.areaid = '';
      this.addrecieverquery.address = '';

      this.cityquery.parentid = '';
      this.citylists = [];
      this.areaquery.parentid = '';
      this.arealists = [];
      //获取京东省份信息
      this.getjdprovince();
    },

    /** 获取待编辑的收件人信息 **/
    editreciever(item) {
      this.addrecieverDialog = true;
      this.addrecieverquery.act = "editreciever";
      this.addrecieverquery.id = item.id;
      this.addrecieverquery.name = item.name;
      this.addrecieverquery.phone = item.phone;
      this.addrecieverquery.provinceid = item.provinceid;

      this.addrecieverquery.cityid = item.cityid == 0 ? item.areaid : item.cityid;
      this.addrecieverquery.areaid = item.cityid == 0 ? '' : item.areaid;
      this.addrecieverquery.address = item.address;

      this.getjdprovince();
      this.cityquery.parentid = this.addrecieverquery.provinceid;
      this.getjdcity();
      this.areaquery.parentid = this.addrecieverquery.cityid;
      this.getjdarea();
    },

    /** 保存收件人信息 **/
    saveaddreciever() {
      var resource = this.$resource(this.GLOBAL.domain + "Order/index");
      resource.save(this.addrecieverquery).then((res) => {
        if (res.data.Result > 0) {
          if (res.data.Result == '70001') this.$router.push('/login')
          this.$message.error(res.data.Message);
        } else {
          this.addrecieverDialog = false;
          this.getrecieverlistsdata();
        }
      }).catch((res) => {

      });
    },

    /** 删除收件人信息 **/
    delreciever(item) {
      this.$confirm('您是否需要删除该收件人信息？', { type: 'warning' }).then(() => {
        var resource = this.$resource(this.GLOBAL.domain + "Order/index");
        resource.query({ act: 'delreciever', token: this.$cookies.get('token'), id: item.id }).then((res) => {
          if (res.data.Result > 0) {
            if (res.data.Result == '70001') this.$router.push('/login')
            this.$message.error(res.data.Message);
          } else {
            this.getrecieverlistsdata();
          }
        }).catch((res) => {

        });
      }).catch(() => {

      });
    },

    //收件人信息
    /////////////////////////////////////////////////////////////////////////







    ///////////////////////////////////////////////////////////////////////////
    //获取城市、切换城市信息

    /** 搜索京东省份信息 **/
    getjdprovince() {
      this.provincelists = [];
      var resource = this.$resource(this.GLOBAL.domain + "Order/index");
      resource.query(this.provincequery).then((res) => {
        if (res.data.Result > 0) {
          if (res.data.Result == '70001') this.$router.push('/login')
          this.$message.error(res.data.Message);
        } else {
          this.provincelists = JSON.parse(Base64.decode(res.data.Data));
        }
      }).catch((res) => {

      });
    },


    /** 搜索京东城市信息 **/
    getjdcity() {
      this.citylists = [];
      var resource = this.$resource(this.GLOBAL.domain + "Order/index");
      resource.query(this.cityquery).then((res) => {
        if (res.data.Result > 0) {
          if (res.data.Result == '70001') this.$router.push('/login')
          this.$message.error(res.data.Message);
        } else {
          this.citylists = JSON.parse(Base64.decode(res.data.Data));
        }
      }).catch((res) => {

      });
    },


    /** 搜索京东区域 / 县信息 **/
    getjdarea() {
      this.arealists = [];
      var resource = this.$resource(this.GLOBAL.domain + "Order/index");
      resource.query(this.areaquery).then((res) => {
        if (res.data.Result > 0) {
          if (res.data.Result == '70001') this.$router.push('/login')
          this.$message.error(res.data.Message);
        } else {
          this.arealists = JSON.parse(Base64.decode(res.data.Data));
        }
      }).catch((res) => {

      });
    },


    /** 切换省份 **/
    changeprovince(val) {
      this.addsenderquery.cityid = '';
      this.addsenderquery.areaid = '';
      this.addrecieverquery.cityid = '';
      this.addrecieverquery.areaid = '';

      if (val > 0) {
        this.cityquery.parentid = val;
        this.getjdcity();
        this.areaquery.parentid = '';
        this.arealists = [];
      } else {
        this.cityquery.parentid = '';
        this.citylists = [];
        this.areaquery.parentid = '';
        this.arealists = [];
      }
    },


    /** 切换城市 **/
    changecity(val) {
      this.addsenderquery.areaid = '';
      this.addrecieverquery.areaid = '';
      if (val > 0) {
        this.areaquery.parentid = val;
        this.getjdarea();
      } else {
        this.areaquery.parentid = '';
        this.arealists = [];
      }
    },

    //获取城市、切换城市信息
    ////////////////////////////////////////////////////////////////////////


    ////////////////////////////////////////////////////////////////////////
    //新增快递单信息

    /** 新增快递单号信息 **/
    addlogisticsorder() {
      this.addlogisticsDialog = true;
      this.addlogisticsquery.id = '';
      this.addlogisticsquery.sells = [];
      this.addlogisticsquery.shippings = [];
      this.addlogisticsquery.clickshippingindex = -1;
      this.addlogisticsquery.loading = false;

      //新增打印快递单信息
      var resource = this.$resource(this.url);
      resource.query({ act: 'addlogisticsorder', token: this.$cookies.get('token') }).then((res) => {
        if (res.data.Result > 0) {
          if (res.data.Result == '70001') this.$router.push('/login')
          this.$message.error(res.data.Message);
        } else {
          var data = JSON.parse(Base64.decode(res.data.Data));
          this.addlogisticsquery.id = data.id;
          this.getprintsdata();
        }
      }).catch((res) => {

      });

    },


    /** 添加快递单信息（新增物流单） **/
    addlogistics() {
      var resource = this.$resource(this.url);
      resource.query({ act: 'addlogisticsshippinginfos', id: this.addlogisticsquery.id, token: this.$cookies.get('token') }).then((res) => {
        if (res.data.Result > 0) {
          if (res.data.Result == '70001') this.$router.push('/login')
          this.$message.error(res.data.Message);
        } else {
          this.getownlogisticssells(this.addlogisticsquery.id);
          this.getownlogisticsshippings(this.addlogisticsquery.id);
        }
      }).catch((res) => {

      });

    },

    /** 删除快递单信息（删除物流单） **/
    delshippings(item, index) {
      this.$confirm('删除该快递单信息会将该快递 ? 绑定的商品信息释放，是否删除 ?', '提示', { type: 'warning' }).then(() => {
        this.addlogisticsquery.clickshippingindex = -1;
        var resource = this.$resource(this.url);
        resource.query({ act: 'delshippingdetails', id: this.addlogisticsquery.id, shippingid: item.id, token: this.$cookies.get('token') }).then((res) => {
          if (res.data.Result > 0) {
            if (res.data.Result == '70001') this.$router.push('/login')
            this.$message.error(res.data.Message);
          } else {
            this.getownlogisticssells(this.addlogisticsquery.id);
            this.getownlogisticsshippings(this.addlogisticsquery.id);
          }
        }).catch((res) => {

        });

      }).catch(() => {

      });
    },

    /** 点击选中当前快递单信息 **/
    selectshippings(index) {
      this.addlogisticsquery.clickshippingindex = index;
      this.addlogisticsquery.localshippings = this.addlogisticsquery.shippings[index];
      this.sendermatchaddress = '';
      this.receivermatchaddress = '';
    },

    /** 获取发货人信息 **/
    shippinggetsender() {
      this.senderDialog = true;
      this.senderquery.key = '';
      this.senderquery.p = 1;
      this.senderquery.rollpage = 10;
      this.senderlists = [];
      this.senderrows = 0;
      this.issenderselect = true;
      this.getsenderlistsdata();
    },

    /** 选择寄件人信息 **/
    selectsender(item) {
      this.senderDialog = false;
      //服务端交互待定
      var id = this.addlogisticsquery.shippings[this.addlogisticsquery.clickshippingindex].id;
      var resource = this.$resource(this.url);
      resource.query({ act: 'savelogisticssender', id: id, senderid: item.id, token: this.$cookies.get('token') }).then((res) => {
        if (res.data.Result > 0) {
          if (res.data.Result == '70001') this.$router.push('/login')
          this.$message.error(res.data.Message);
        } else {
          this.getownlogisticssells(this.addlogisticsquery.id);
          this.getownlogisticsshippings(this.addlogisticsquery.id);
        }
      }).catch((res) => {

      });


    },


    /** 获取收货人信息 **/
    shippinggetreciever() {
      this.recieverDialog = true;
      this.recieverquery.key = '';
      this.recieverquery.loading = false;
      this.recieverquery.ischange = false;
      this.recieverquery.p = 1;
      this.recieverquery.rollpage = 10;
      this.recieverlists = [];
      this.recieverrows = 0;
      this.isrecieverselect = true;
      this.getrecieverlistsdata();
    },

    /** 选取收货人信息 **/
    selectreciever(item) {
      this.recieverDialog = false;
      var id = this.addlogisticsquery.shippings[this.addlogisticsquery.clickshippingindex].id;
      var resource = this.$resource(this.url);
      resource.query({ act: 'savelogisticsreciever', id: id, recieverid: item.id, token: this.$cookies.get('token') }).then((res) => {
        if (res.data.Result > 0) {
          if (res.data.Result == '70001') this.$router.push('/login')
          this.$message.error(res.data.Message);
        } else {
          this.getownlogisticssells(this.addlogisticsquery.id);
          this.getownlogisticsshippings(this.addlogisticsquery.id);
        }
      }).catch((res) => {

      });

    },

    //新增快递单信息
    ////////////////////////////////////////////////////////////////////////


    ////////////////////////////////////////////////////////////////////////
    //编辑快递鸟打印订单信息

    //获取编辑打印电子面单信息
    getshippinglogistics(item) {
      this.addlogisticsDialog = true;
      this.addlogisticsquery.id = item.id;
      this.addlogisticsquery.sells = [];
      this.addlogisticsquery.shippings = [];
      this.addlogisticsquery.clickshippingindex = -1;

      //获取电子面单已选中的销售单以及销售单未选中的商品信息
      this.getownlogisticssells(item.id);
      //获取已添加的快递单信息
      this.getownlogisticsshippings(item.id);

    },

    //获取电子面单已选中的销售单以及销售单未选中的商品信息
    getownlogisticssells(id) {
      this.sellgoodsnums = 0;
      this.addlogisticsquery.loading = true;
      this.addlogisticsquery.sells = [];
      //新增打印快递单信息
      var resource = this.$resource(this.url);
      resource.query({ act: 'getownsells', id: id, token: this.$cookies.get('token') }).then((res) => {
        if (res.data.Result > 0) {
          if (res.data.Result == '70001') this.$router.push('/login')
          this.$message.error(res.data.Message);
          this.addlogisticsquery.loading = false;
        } else {
          this.addlogisticsquery.sells = JSON.parse(Base64.decode(res.data.Data));
          this.addlogisticsquery.loading = false;
          let _this = this;
          this.addlogisticsquery.sells.forEach(function (e, i) {
            e.goods.forEach(function (ee, ii) { _this.sellgoodsnums++; })
          });
        }
      }).catch((res) => {
        this.addlogisticsquery.loading = false;
      });
    },

    //获取已添加的快递单信息
    getownlogisticsshippings(id) {
      this.addlogisticsquery.shippings = [];
      this.addlogisticsquery.loading1 = true;
      //新增打印快递单信息
      var resource = this.$resource(this.url);
      resource.query({ act: 'getownshippings', id: id, token: this.$cookies.get('token') }).then((res) => {
        if (res.data.Result > 0) {
          if (res.data.Result == '70001') this.$router.push('/login')
          this.$message.error(res.data.Message);
          this.addlogisticsquery.loading1 = false;
        } else {
          this.addlogisticsquery.shippings = JSON.parse(Base64.decode(res.data.Data));
          if (this.addlogisticsquery.clickshippingindex > -1) this.addlogisticsquery.localshippings = this.addlogisticsquery.shippings[this.addlogisticsquery.clickshippingindex];
          this.addlogisticsquery.loading1 = false;
        }
      }).catch((res) => {
        this.addlogisticsquery.loading1 = false;
      });
    },


    //将销售单商品信息添加到右边的快递单中
    matchgoodstosell(i, ii) {
      if (this.addlogisticsquery.clickshippingindex == -1) { this.$message.error('请选择要分配的快递单'); return false; }
      var sellid = this.addlogisticsquery.sells[i].sellid;
      var selldetailid = this.addlogisticsquery.sells[i].goods[ii].selldetailid;

      var sells = this.addlogisticsquery.sells[i];
      var goods = this.addlogisticsquery.sells[i].goods[ii];
      var shippingid = this.addlogisticsquery.shippings[this.addlogisticsquery.clickshippingindex].id;
      var data = { sellid: sells.sellid, paytype: sells.paytype, documents: sells.documents, selldetailid: goods.selldetailid, productid: goods.productid, productname: goods.productname, num: goods.num, unit: goods.unit, type: goods.type, orderfrom: goods.orderfrom };

      this.$delete(this.addlogisticsquery.sells[i].goods, ii);
      this.addlogisticsquery.shippings[this.addlogisticsquery.clickshippingindex].goods.push(data);

      var resource = this.$resource(this.url);
      resource.query({ act: 'matchgoods', shippingid: shippingid, sellid: sellid, selldetailid: selldetailid, orderfrom: goods.orderfrom, token: this.$cookies.get('token') }).then((res) => {
        if (res.data.Result > 0) {
          if (res.data.Result == '70001') this.$router.push('/login')
          this.$message.error(res.data.Message);
        } else {
          this.sellgoodsnums--;
        }
      }).catch((res) => {

      });
    },

    //释放商品信息
    rollbackgoods(item, index) {
      var _this = this;
      var data = this.addlogisticsquery.shippings[this.addlogisticsquery.clickshippingindex].goods[index];
      this.$delete(this.addlogisticsquery.shippings[this.addlogisticsquery.clickshippingindex].goods, index);
      this.addlogisticsquery.sells.forEach(function (e, i) {
        if (e.sellid == data.sellid) e.goods.push({ id: e.id, selldetailid: data.selldetailid, productid: data.productid, productname: data.productname, num: data.num, unit: data.unit, type: data.type, isshow: true, orderfrom: item.orderfrom });
      });

      var resource = this.$resource(this.url);
      resource.query({ act: 'rollbackmatchgoods', id: data.id, token: this.$cookies.get('token') }).then((res) => {
        if (res.data.Result > 0) {
          if (res.data.Result == '70001') this.$router.push('/login')
          this.$message.error(res.data.Message);
        } else {
          this.sellgoodsnums++;
        }
      }).catch((res) => {

      });

    },

    //提交信息到快递鸟
    submitshippingtobirld(item) {
      this.$confirm('该操作为将当前快递信息提交至快递鸟，且成功后不可撤回不可删除，是否继续 ？', { type: 'warning' }).then(() => {
        var resource = this.$resource(this.url);
        resource.query({ act: 'submittobirld', id: item.id, token: this.$cookies.get('token') }).then((res) => {
          if (res.data.Result > 0) {
            if (res.data.Result == '70001') this.$router.push('/login')
            this.$message.error(res.data.Message);
          } else {
            this.getownlogisticsshippings(this.addlogisticsquery.id);
          }
        }).catch((res) => {

        });

      }).catch(() => {

      });
    },


    //打印快递单信息
    printshippinglogistics(item) {
      var resource = this.$resource(this.url);
      resource.query({ act: 'printlogisticsmore', id: item.id, token: this.$cookies.get('token') }).then((res) => {
        if (res.data.Result > 0) {
          if (res.data.Result == '70001') this.$router.push('/login')
          this.$message.error(res.data.Message);
        } else {
          this.printerlists = JSON.parse(Base64.decode(res.data.Data));
          this.printDialog = true;

          var _this = this;
          var JsBarcode = require('jsbarcode'); //条形码
          var qr = '';  //二维码
          var content = '';

          setTimeout(function () { //生成条形码、二维码进行填充
            _this.printerlists.forEach(function (item, index) {
              content = item.code;
              JsBarcode(document.getElementById(item.bacodeid), content, { //生成条形码
                format: "CODE128",//选择要使用的条形码类型
                width: 5,//设置条之间的宽度
                height: 100,//高度
                displayValue: true,//是否在条形码下方显示文字
                text: '' + content + '',//覆盖显示的文本
                fontOptions: "",//使文字加粗体或变斜体
                font: "fantasy",//设置文本的字体
                textAlign: "center",//设置文本的水平对齐方式
                textPosition: "bottom",//设置文本的垂直位置
                textMargin: 5,//设置条形码和文本之间的间距
                fontSize: 30,//设置文本的大小
                background: "#fff",//设置条形码的背景
                lineColor: "#000",//设置条和文本的颜色。
                margin: 10//设置条形码周围的空白边距
              });

              document.getElementById(item.ercodeid).innerHTML = "";
              qr = new QRCode(document.getElementById(item.ercodeid), { //生成二维码
                text: 'http://www.zto.com',
                width: 65,
                height: 65,
                colorDark: '#000000',
                colorLight: '#ffffff',
              });

            });

          }, 200);
        }
      }).catch((res) => {

      });
    },


    //选择、取消选择要打印的快递单
    selectprints(item) {
      item.check ? item.check = false : item.check = true;
    },


    //打印快递单信息
    printlocalpage() {
      var number = 0;
      this.printerlists.forEach(function (item, index) { item.check ? number++ : '' });
      if (number == 0) { this.$message.error("请至少选择一个要打印的快递单"); return false; }
      this.printendsDialog = true;

      var _this = this;
      var JsBarcode = require('jsbarcode'); //条形码
      var qr = '';  //二维码
      var content = '';
      setTimeout(function () { //生成条形码、二维码进行填充
        _this.printerlists.forEach(function (item, index) {
          if (item.check) {
            content = item.code;
            JsBarcode(document.getElementById(item.bacodeendid), content, { //生成条形码
              format: "CODE128",//选择要使用的条形码类型
              width: 5,//设置条之间的宽度
              height: 100,//高度
              displayValue: true,//是否在条形码下方显示文字
              text: '' + content + '',//覆盖显示的文本
              fontOptions: "",//使文字加粗体或变斜体
              font: "fantasy",//设置文本的字体
              textAlign: "center",//设置文本的水平对齐方式
              textPosition: "bottom",//设置文本的垂直位置
              textMargin: 5,//设置条形码和文本之间的间距
              fontSize: 30,//设置文本的大小
              background: "#fff",//设置条形码的背景
              lineColor: "#000",//设置条和文本的颜色。
              margin: 10//设置条形码周围的空白边距
            });

            document.getElementById(item.ercodeendid).innerHTML = "";
            qr = new QRCode(document.getElementById(item.ercodeendid), { //生成二维码
              text: 'http://www.zto.com',
              width: 65,
              height: 65,
              colorDark: '#000000',
              colorLight: '#ffffff',
            });
          }
        });
      }, 200);

      //执行页面打印
      setTimeout(function () {
        var div_print = document.getElementById('shippingprintend');
        var newStr = div_print.innerHTML;
        var oldStr = document.body.innerHTML;
        document.body.innerHTML = newStr;
        window.print();
        document.body.innerHTML = oldStr;
        location.reload();
      }, 500);
    },


    //编辑快递鸟打印订单信息
    ////////////////////////////////////////////////////////////////////////
    deleteshippinglogistics(item) {
      this.$confirm('您是否需要删除打印单信息 ?', '提示', { type: 'warning' }).then(() => {
        var resource = this.$resource(this.url);
        resource.query({ act: 'delprinter', id: item.id, token: this.$cookies.get('token') }).then((res) => {
          if (res.data.Result > 0) {
            if (res.data.Result == '70001') this.$router.push('/login')
            this.$message.error(res.data.Message);
          } else {
            this.getprintsdata();
          }
        }).catch((res) => {

        });

      }).catch(() => {

      });
    },


    /** 修改快递重量信息 **/
    changeshippingweight(id, weight) {
      var resource = this.$resource(this.url);
      resource.save({ act: 'changeshippingweight', id: id, weight: weight, token: this.$cookies.get('token') }).then((res) => {
        if (res.data.Result > 0) {
          if (res.data.Result == '70001') this.$router.push('/login')
          this.$message.error(res.data.Message);
        } else {

        }
      }).catch((res) => {

      });
    },


    /** 智能识别快递信息 **/
    matchaddress(type) {
      var printid = this.addlogisticsquery.id;
      var logisticsid = this.addlogisticsquery.localshippings.id;

      var resource = this.$resource(this.url);
      resource.save({ act: 'matchaddress', id: printid, logisticsid: logisticsid, type: type, address: type == 1 ? this.sendermatchaddress : this.receivermatchaddress, token: this.$cookies.get('token') }).then((res) => {
        if (res.data.Result > 0) {
          if (res.data.Result == '70001') this.$router.push('/login')
          this.$message.error(res.data.Message);
        } else {
          this.sendermatchaddress = '';
          this.receivermatchaddress = '';
          this.getownlogisticssells(this.addlogisticsquery.id);
          this.getownlogisticsshippings(this.addlogisticsquery.id);
        }
      }).catch((res) => {

      });
    },


    /** 导出物流记录信息 **/
    outputshippings() {


      // 设置导出参数
      this.query.act = 'generate_waybill_list';
      this.query.excel = 1;


      const copyQuery = JSON.parse(JSON.stringify(this.query));
      copyQuery.excel = 1

      const url = new URL(this.url);
      Object.keys(copyQuery).forEach(key => url.searchParams.append(key, copyQuery[key]));

      const link = document.createElement('a');
      link.href = url.toString();
      link.download = 'filename.xlsx'; // 设置下载文件的名称
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },



    /** 切换搜索 **/
    changeselltype() {
      this.sellquery.p = 1;
      this.sellquery.rollpage = 10;
      this.sellquery.key = '';
      this.selltemps = [];
      this.selldatalists();
    },






    /** 查看快递单物流信息 **/
    lookshipping() {
      this.$emit('listenchild', { name: '物流信息查询', url: 'checkshippings', data: { checkshippingtype: '', checkshippingsid: '' } });
    },

    /** 查看打印单对应的物流信息 **/
    checkshippings(item) {
      this.$emit('listenchild', { name: '物流信息查询', url: 'checkshippings', data: { checkshippingtype: 4, checkshippingsid: item.id } });
    },


    /** 快速打印电子面单 **/
    print_direct(row) {

      // 必填数据 ！！！！
      let key = ''; // 快递鸟 API Key
      let id = ''; // 快递鸟用户id
      const isPreview = '1'; // 是否预览，0-不预览 1-预览

      let requestData = [] // 打印数据


      if (!row) {
        // 批量打印逻辑
        let printDisabled = !this.allSelection.every(item => item.recycle_status == 1)

        if (this.allSelection.length < 1 || printDisabled) {
          this.$message.error('无效的打印任务！')
          return
        }
        // 获取expressRef表单中已选中的表单数据

        this.allSelection.forEach(element => {
          if (!key) {
            key = element.kdniao_secret_key
            id = element.kdniao_app_id
          }
          const object = {
            OrderCode: element.order_code,
            PortName: ""
          }
          requestData.push(object)
        });
      } else {
        // 单个打印逻辑
        key = row.kdniao_secret_key
        id = row.kdniao_app_id
        requestData = [{
          OrderCode: row.order_code,
          PortName: ""
        }]

      }
      requestData = JSON.stringify(requestData)

      // MD5加密
      const md5str = md5(requestData + key).toLowerCase();
      // base64
      const dataSign = Base64.encode(md5str);

      // 创建一个隐藏的表单
      const form = document.createElement('form');
      form.action = 'http://www.kdniao.com/External/PrintOrder.aspx'; // 快递鸟打印地址
      form.target = '_blank';
      form.method = 'POST';

      // 添加表单字段
      const requestDataInput = document.createElement('input');
      requestDataInput.type = 'hidden';
      requestDataInput.name = 'RequestData';
      requestDataInput.value = requestData;
      form.appendChild(requestDataInput);

      const dataSignInput = document.createElement('input');
      dataSignInput.type = 'hidden';
      dataSignInput.name = 'DataSign';
      dataSignInput.value = dataSign;
      form.appendChild(dataSignInput);

      const idInput = document.createElement('input');
      idInput.type = 'hidden';
      idInput.name = 'EBusinessID';
      idInput.value = id;
      form.appendChild(idInput);

      const isPreviewInput = document.createElement('input');
      isPreviewInput.type = 'hidden';
      isPreviewInput.name = 'IsPreview';
      isPreviewInput.value = isPreview;
      form.appendChild(isPreviewInput);

      // 将表单添加到 body 并提交
      document.body.appendChild(form);
      form.submit();
      document.body.removeChild(form);

      // 打印状态回调，通知后端已打印
      const printIds = this.allSelection.map(item => item.id)
      this.$axios({
        url: this.url,
        method: 'POST',
        data: {
          act: 'print_callback',
          id: row ? row.id : printIds.join(',')
        }
      })
        .then(res => {
          this.getprintsdata()
        });
    },


  }
}
</script>

</script>
<style type="text/css">
.backborder1 {
  background: #fff;
  border-radius: 15px;
  border: 1px solid #ddd;
  padding: 1% 1% 0 1%
}

.backborder2 {
  background: #fff;
  border-radius: 15px;
  border: 1px solid #ddd;
  padding: 1% 1% 3% 1%
}

.sell-shipping-birld {
  float: left;
  width: 96%;
  height: 420px;
  padding: 0 2%;
  background: rgb(221, 221, 221, .3);
  font-size: 13px;
  border-radius: 5px;
  border-bottom: 1px solid #999999
}

.sell-shipping-left {
  float: left;
  width: 37%;
  padding: 0 3% 0 0;
  height: 420px;
  border-right: 1px solid #666666;
  overflow: hidden
}

.sell-shipping-left-title {
  float: left;
  width: 100%;
  padding: 10px 0
}

.sell-shipping-left-title span {
  float: left;
  font-size: 14px;
  font-weight: bold
}

.sell-shipping-left-title span i {
  font-style: normal;
  font-weight: normal;
  font-size: 13px
}

.sell-shipping-left ul {
  float: left;
  width: 100%;
  padding: 0;
  margin: 0;
  height: 365px;
  overflow-y: scroll;
}

.sell-shipping-left ul::-webkit-scrollbar {
  width: 0;
  height: 0px;
}

.sell-shipping-left li {
  float: left;
  width: 100%;
  padding: 10px 0;
  list-style-type: none;
}

.sell-shipping-documents {
  float: left;
}

.sell-shipping-right {
  float: left;
  width: 53%;
  padding: 0 3% 0 3%;
  height: 420px;
  overflow: hidden
}

.sell-shipping-right-title {
  float: left;
  width: 100%;
  padding: 10px 0
}

.sell-shipping-right-title span {
  float: left;
  font-size: 14px;
  font-weight: bold
}

.sell-shipping-right-title span i {
  font-style: normal;
  font-weight: normal;
  font-size: 13px
}

.sell-shipping-right ul {
  float: left;
  width: 100%;
  padding: 10px 0 0 0;
  margin: 0;
  height: 365px;
  overflow-y: scroll;
}

.sell-shipping-right ul::-webkit-scrollbar {
  width: 0;
  height: 0px;
}

.sell-shipping-right li {
  transition: all .3s;
  float: left;
  width: 45%;
  list-style-type: none;
  border: 1px solid #dddddd;
  border-radius: 5px;
  background: #fff;
  margin-bottom: 10px;
  cursor: pointer;
  font-size: 12px
}

.sell-shipping-right li:nth-child(odd) {
  margin-right: 4%
}

.sell-shipping-right li .shippingmessage {
  float: left;
  width: 90%;
  padding: 10px 5%;
  border-bottom: 1px solid #dddddd
}

.sell-shipping-right li .shippingmessage .el-button--mini.is-circle {
  padding: 5px !important;
  margin-left: 5px
}

.sell-shipping-right li .shippingmessage span {
  float: left;
  width: 60%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.sell-shipping-right li:hover {
  box-shadow: 3px 5px 10px #666666
}

.shippingmessage-content {
  float: left;
  width: 90%;
  padding: 10px 5%
}

.shippingmessage-content span {
  float: left;
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  line-height: 25px
}

.sell-shipping-content-alls {
  float: left;
  width: 96%;
  height: 700px;
  padding: 0 2%;
  background: rgb(221, 221, 221, .3);
  font-size: 13px;
  border-radius: 5px;
  margin-bottom: 30px
}

.sell-shipping-all-left {
  float: left;
  width: 37%;
  padding: 0 3% 0 0;
  height: 700px;
  border-right: 1px solid #666666;
  overflow: hidden
}

.sell-shipping-all-left-title {
  float: left;
  width: 100%;
  padding: 10px 0
}

.sell-shipping-all-left-title span {
  float: left;
  font-size: 14px;
  font-weight: bold
}

.sell-shipping-all-left-title span i {
  font-style: normal;
  font-weight: normal;
  font-size: 13px
}

.sell-shipping-all-left-contents {
  float: left;
  width: 100%;
  height: 570px;
  overflow-y: scroll;
}

.sell-shipping-all-left-contents::-webkit-scrollbar {
  width: 0;
  height: 0px;
}

.sell-shipping-all-left-contents ul {
  padding: 0 0;
  margin: 0;
  float: left;
  width: 100%
}

.sell-shipping-all-left-contents li {
  float: left;
  width: 100%;
  padding: 10px 0;
  list-style-type: none;
}

.sell-shipping-all-left-contents li .sell-shipping-all-left-checkbox {
  float: left;
  margin-top: 10px
}

.sell-shipping-all-left-checkbox .el-main {
  line-height: 0
}

.sell-shipping-all-left-goods {
  float: left;
  margin-left: 5%;
  width: 80%
}

.sell-shipping-all-left-goods .documents {
  float: left;
  width: 100%;
  font-size: 13px;
  line-height: 23px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.sell-shipping-all-left-goods .documents em {
  font-style: normal
}

.sell-shipping-all-left-goods .goods {
  float: left;
  width: 100%;
  font-size: 13px;
  line-height: 23px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.sell-shipping-all-left-goods .goods i {
  float: left;
  margin-right: 5px;
  margin-top: 2px;
  font-size: 12px;
  line-height: 12px;
  padding: 2px 5px;
  border-radius: 5px;
  color: #fff;
  background: red;
  font-style: normal
}

.sell-shipping-all-right {
  float: left;
  width: 53%;
  padding: 0 3% 0 3%;
  height: 700px;
  overflow: hidden;
}

.sell-shipping-all-right-title {
  float: left;
  width: 100%;
  padding: 10px 0
}

.sell-shipping-all-right-title span {
  float: left;
  font-size: 14px;
  font-weight: bold
}

.sell-shipping-all-right-content {
  float: left;
  width: 100%;
  height: 640px;
  margin-top: 10px;
  overflow: hidden;
}

.sell-shipping-all-right-base {
  float: left;
  width: 100%;
  border-bottom: 1px dashed #999999;
  padding: 5px 0
}

.sell-shipping-all-right-one {
  float: left;
  width: 15%;
  text-align: left;
  font-size: 13px;
  font-weight: bold;
  line-height: 13px;
  padding: 10px 0
}

.sell-shipping-all-right-two {
  float: left;
  width: 75%;
  margin-left: 2%;
  font-size: 13px;
  line-height: 13px;
  padding: 8px 0
}

.sell-shipping-all-right-two span {
  float: left;
  width: 100%;
  padding: 5px 0
}

.sell-shipping-all-right-three {
  float: right;
  text-align: right
}

.sell-shipping-all-right-base1 {
  float: left;
  width: 100%;
  border-bottom: 1px dashed #999999;
  padding: 5px 0
}

.sell-shipping-all-right-one1 {
  float: left;
  width: 15%;
  text-align: left;
  font-size: 13px;
  font-weight: bold;
  line-height: 13px;
  padding: 10px 0;
  margin-top: 20px
}

.sell-shipping-all-right-two1 {
  float: left;
  width: 75%;
  margin-left: 2%;
  font-size: 13px;
  line-height: 13px;
  padding: 8px 0
}

.sell-shipping-all-right-two1 span {
  float: left;
  width: 100%;
  padding: 5px 0
}

.sell-shipping-all-right-three1 {
  float: right;
  text-align: right;
  margin-top: 20px
}

.sell-shipping-all-right-goodsinfos {
  float: left;
  width: 100%;
  height: 260px;
  background: #fff;
  border-radius: 15px;
  margin-top: 20px;
  overflow-y: scroll
}

.sell-shipping-all-right-goodsinfos::-webkit-scrollbar {
  width: 0;
  height: 0px;
}

.sell-shipping-all-right-fourth1 {
  float: left;
  width: 100%
}

.sell-shipping-all-right-fourth1 .el-textarea__inner {
  border-radius: 15px
}

.sell-shipping-all-right-fourth1 textarea::placeholder {
  font-size: 13px;
  line-height: 23px
}

.sell-shipping-all-right-goodsinfos ul {
  padding: 0 0;
  margin: 0;
  float: left;
  width: 100%
}

.sell-shipping-all-right-goodsinfos li {
  float: left;
  width: 100%;
  padding: 10px 0;
  list-style-type: none;
}

.sell-shipping-all-right-goodsinfos li .sell-shipping-all-left-checkbox {
  float: left;
  margin-top: 10px
}

.sell-shipping-all-right-goodsinfos .sell-shipping-all-right-goods {
  float: left;
  margin-left: 5%;
  width: 80%
}

.sell-shipping-all-right-goodsinfos .sell-shipping-all-right-goods .documents {
  float: left;
  width: 100%;
  font-size: 13px;
  line-height: 23px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.sell-shipping-all-right-goodsinfos .sell-shipping-all-right-goods .goods {
  float: left;
  width: 100%;
  font-size: 13px;
  line-height: 23px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.sell-shipping-all-right-goodsinfos .sell-shipping-all-right-goods .goods i {
  float: left;
  margin-right: 5px;
  margin-top: 2px;
  font-size: 12px;
  line-height: 12px;
  padding: 2px 5px;
  border-radius: 5px;
  color: #fff;
  background: red;
  font-style: normal
}

.sell-select-goodslists {
  float: left;
  width: 94%;
  border-radius: 5px;
  padding: 10px 2%;
  background: rgba(221, 221, 221, .5);
  margin-bottom: 10px
}

.sell-select-detail {
  float: left;
  margin: 0 10px 10px 0
}

.sender-reciever-infos .el-table {
  font-size: 13px
}

/** 打印电子面单模板 **/
.shippingprinttemp {
  width: 76mm;
  height: 130mm !important;
  padding: 10px;
  margin: 0 auto;
  overflow: hidden;
  position: relative;
  border: 1px solid #dddddd;
  transition: .3s all;
  cursor: pointer
}

.shippingprinttemp:hover {
  box-shadow: 0 0 10px #000000
}

/**
.printtime {width:100%;color:#333;padding-bottom:5px;border-bottom:1px solid #333333;font-size:13px;float:left}
.codeout {width:100%;float:left;}
.sourse {float:left;width:100%;padding:10px 0;border-top:1px solid #333333}
.sourse .sourse-left {float:left;font-size:23px;font-weight:bold;line-height:23px}
.sourse .sourse-right {float:left;font-size:16px;margin-left:5px;line-height:16px}
.shippingsender {float:left;width:100%;padding:15px 0;border-top:1px solid #333333;border-bottom:1px solid #333333}
.shippingsender .senderlogo {float:left;color:#fff;background:#333333;-webkit-print-color-adjust: exact;padding:5px;font-size:23px;line-height:23px}
.shippingsender .senderright {float:left;width:220px;margin-left:10px;}
.shippingsender .senderright .sendername {float:left;font-size:15px;line-height:15px}
.shippingsender .senderright .senderphone {float:left;margin-left:30px;font-size:15px;line-height:15px}
.shippingsender .senderright .senderaddress {float:left;width:100%;font-size:13px;line-height:18px;margin-top:5px}
.shippingreciever {float:left;width:100%;border-bottom:1px solid #333333}
.shippingreciever .recieverleft {float:left;width:33%;height:90px;border-right:1px solid #333333}
.shippingreciever .recieverleft .recieverlogo {float:left;color:#fff;background:#333333;-webkit-print-color-adjust: exact;padding:5px;font-size:23px;line-height:23px;margin-top:5px}
.shippingreciever .recieverleft .recievername {float:left;width:100%;font-size:14px;line-height:14px;text-align:left;margin-top:5px}
.shippingreciever .recieverleft .recieverphone {float:left;width:100%;font-size:14px;line-height:14px;text-align:left;margin-top:5px}
.shippingreciever .recievercenter {float:left;width:33%;height:90px;border-right:1px solid #333333}
.shippingreciever .recievercenter .ercode {float:left;width:70px;height:70px;margin:5px 0 0 12px;}
.shippingreciever .recieverright {float:left;width:32%;height:90px;}
.recieverright .recieverrighttop {float:left;width:100%;border-bottom:1px solid #333333}
.recieverright .recieverrighttop span {float:left;width:100%;text-align:center;padding:3px 0;font-size:14px;line-height:14px}
.recieverright .recieverrightbottom {float:left;width:100%;}
.recieverright .recieverrightbottom span {float:left;width:100%;text-align:center;padding:5px 0;font-size:15px;line-height:15px;font-weight:bold}
*/

.printtime {
  width: 100%;
  color: #000;
  font-size: 12px;
  line-height: 15px;
  float: left
}

.printpage {
  width: 50%;
  color: #000;
  font-size: 12px;
  line-height: 15px;
  float: right
}

.MarkDestination {
  width: 100%;
  float: left;
  color: #000;
  font-size: 25px;
  font-weight: bold;
  text-align: center;
  padding-bottom: 5px;
  border-bottom: 2px solid #000;
}

.codeout {
  width: 100%;
  float: left;
}

.infomain {
  float: left;
  width: 100%;
  border-top: 2px solid #000;
  border-bottom: 2px solid #000;
}

.infomain .left {
  float: left;
  width: 100%;
}

.infomain .right {
  float: left
}

.infomain .packagename {
  float: left;
  padding: 5px 0 5px 5%;
  width: 95%;
  color: #000;
  font-size: 18px;
  font-weight: bold;
  letter-spacing: 5px;
  border-bottom: 2px solid #333
}

.sender {
  float: left;
  width: 100%;
  height: 68px;
  border-bottom: 2px solid #000;
}

.sender .senderlogo {
  float: left;
  width: 15%;
  height: 65px;
  padding-top: 25px;
  text-align: center;
}

.sender .senderlogo span {
  font-size: 15px;
  line-height: 15px;
  font-weight: bold;
  color: #fff;
  background: #000;
  padding: 5px;
  -webkit-print-color-adjust: exact;
}

.sender .sendercontent {
  float: left;
  width: 84%;
  height: 70px;
  padding: 0 0;
  border-left: 2px solid #000
}

.sender .sendername {
  float: left;
  margin: 10px 10px 3px 5px;
  font-size: 13px;
  line-height: 13px;
  font-weight: bold
}

.sender .senderphone {
  float: left;
  margin: 10px 10px 3px 5px;
  font-size: 13px;
  line-height: 13px;
  font-weight: bold
}

.sender .sendercity {
  float: left;
  width: 96%;
  margin: 2% 10px 3px 2%;
  font-size: 13px;
  line-height: 17px
}

.reciever {
  float: left;
  width: 100%;
  height: 65px;
  border-bottom: 2px solid #000
}

.reciever .recieverlogo {
  float: left;
  width: 15%;
  height: 45px;
  padding-top: 20px;
  text-align: center;
}

.reciever .recieverlogo span {
  font-size: 15px;
  line-height: 15px;
  font-weight: bold;
  color: #fff;
  background: #000;
  padding: 5px;
  -webkit-print-color-adjust: exact;
}

.reciever .recievercontent {
  float: left;
  width: 84%;
  height: 65px;
  padding: 0 0;
  border-left: 2px solid #000
}

.reciever .recievername {
  float: left;
  margin: 10px 10px 3px 5px;
  font-size: 13px;
  line-height: 13px;
  font-weight: bold
}

.reciever .recieverphone {
  float: left;
  margin: 10px 10px 3px 5px;
  font-size: 12px;
  line-height: 12px;
  font-weight: bold
}

.reciever .recievercity {
  float: left;
  width: 96%;
  margin: 2% 10px 3px 2%;
  font-size: 12px;
  line-height: 15px
}

.infomain .left .shippingbotton {
  float: left;
  width: 96%;
  padding: 0 2%;
  height: 106px
}

.infomain .left .ercode {
  float: left;
  width: 25%;
  margin-top: 5px
}

.infomain .left .notice {
  float: left;
  width: 71%;
  font-size: 12px;
  transform: scale(0.95, 0.95);
  line-height: 15px;
  text-align: left;
  margin-top: 2px;
  padding: 0
}

.infomain .left .sign {
  float: left;
  font-size: 13px;
  line-height: 13px;
  font-weight: bold;
  margin: 5px 2%
}

.infomain .left .note {
  float: left;
  width: 100%;
  font-size: 12px;
  line-height: 12px;
  transform: scale(0.95, 0.95);
  -webkit-transform-origin-x: 0;
  text-align: left;
  margin: 5px 0
}

.infomain .left .note i {
  font-style: normal;
  font-size: 14px;
  font-weight: bold;
  margin-left: 2%
}

@page {
  size: auto;
  margin: 0mm;
}
</style>


// WEBPACK FOOTER //
// src/components/home/sellshippingbirld.vue